import { render, staticRenderFns } from "./TabelaFornecedores.vue?vue&type=template&id=13f8a0ab&"
import script from "./TabelaFornecedores.vue?vue&type=script&lang=js&"
export * from "./TabelaFornecedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports